import { getPricesState } from './../modules/retail-review/selectors/prices.selector';
import { createSelector } from '@ngrx/store';
import { getDraftState } from '../modules/review/reducers/draft.selectors';
import {
  getAnticipatedInvoiceState,
  getBusinessLinePage,
  getSummaryPage,
  getCalendars,
  getSelectedBusinessLine,
  getActiveExperienceCode,
  getPointOfDeliverySelected,
} from '../reducers';
import { getGroupingState } from '../modules/retail-specification/selectors/grouping.selectors';
import { getLegalEntity } from '@cemex/cmx-client-layout';
import { getNewOrderCreation } from '../modules/retail-specification/selectors/retail-specifications.selectors';

/**
 * Basic data needed for order creation
 */
export const getOrderCreateRequestData = createSelector(
  getDraftState,
  getSummaryPage,
  getLegalEntity,
  getGroupingState,
  getPricesState,
  getNewOrderCreation,
  (draftState, summaryState, customer, groupingState, pricesState, newOrderCreation) => {
    return {
      draftState,
      summaryState,
      customer,
      groupingState,
      pricesState,
      newOrderCreation,
    };
  },
);

export const getSolverRequestData = createSelector(
  getOrderCreateRequestData,
  getAnticipatedInvoiceState,
  getCalendars,
  getSelectedBusinessLine,
  getActiveExperienceCode,
  getPointOfDeliverySelected,
  (
    { draftState, summaryState, groupingState },
    invoiceState,
    calendarsState,
    businessLineSelected,
    experienceCode,
    podSelected,
  ) => {
    return {
      draftState,
      summaryState,
      invoiceState,
      groupingState,
      calendarsState,
      businessLineSelected,
      experienceCode,
      podSelected,
    };
  },
);

export const getRouteSelectionFields = createSelector(
  getLegalEntity,
  getBusinessLinePage,
  (customer, businessLineState) => {
    return { customer, businessLineState };
  },
);
